import { get } from 'lodash-es'

export default {
  namespaced: true,
  state: {
    companyNavigation: [
      {
        title: 'Company',
        route: 'company-settings-profile'
      },
      {
        title: 'Loyalty',
        route: 'company-settings-loyalty'
      },
      // {
      //   title: 'Integrations',
      //   route: 'company-settings-integrations'
      // },
      // {
      //   title: 'Tags',
      //   route: 'company-settings-tags',
      // },
      {
        title: 'Keywords',
        route: 'keywords'
      }
    ],
    locationNavigation: [
      // {
      //   title: 'Survey',
      //   route: 'location-settings-survey'
      // },
      { title: 'Platforms', route: 'location-settings-platforms' },
      { title: 'Devices', route: 'location-settings-devices' },
      { title: 'Integrations', route: 'location-settings-integrations' },
      { title: 'Settings', route: 'location-settings-basic' }
    ],
    cttAllowedNavigation: ['winback', 'company-settings-profile', 'account-profile']
  },
  getters: {
    companyNavigation(state, getters, rootState, rootGetters) {
      const loyaltyEnabled = rootGetters['company/loyaltyEnabled']

      return state.companyNavigation.filter((nav) => {
        if (
          (nav.route === 'company-settings-profile' &&
            get(rootState.user, 'onlineUser.role') !== 'admin') ||
          (nav.route === 'keywords' &&
            !rootGetters['company/selectIsPermitted']('keywordsReadAccess'))
        ) {
          return false
        } else if (!loyaltyEnabled && nav.route === 'company-settings-loyalty') {
          return false
        } else {
          return true
        }
      })
    },
    selectCTTAllowedNavigation: (state) => state.cttAllowedNavigation
  }
}
